import React from 'react';

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Communitydetailbanner from '../Components/Communitydetailbanner';
import Communitydetailcardbox from '../Components/Communitydetailcardbox';
import Communitydetailactivitie from '../Components/Communitydetailactivitie';
import CommunityDtlImpact from '../Components/CommunityDtlImpact';
import { API_BASE } from "../api/apiConfig";

const CommunityDtl = () => {
  return (
    <>
      <Header />


<main className="min-h-screen bg-white">
      {/* Hero Section */}
      

      <Communitydetailbanner />

      {/* Stats Section */}
      <div className="max-w-7xl mx-auto px-4 py-6 md:py-8">
      
      <Communitydetailcardbox />

      


<section className="mb-6 md:mb-10">
  {/* mobile */}
  <div className="md:hidden space-y-4">
    {/* mobile */}
    <div className="bg-white rounded-xl border border-slate-200 p-4">
      <div className="flex items-center gap-2 mb-3">
        <div className="p-1.5 bg-primary/10 rounded-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-compass h-4 w-4 text-primary"
          >
            <path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z" />
            <circle cx="12" cy="12" r="10" />
          </svg>
        </div>
        <h3 className="text-base font-bold text-slate-800">Popular Activities</h3>
      </div>
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <div className="h-1.5 w-1.5 rounded-full bg-primary flex-shrink-0" />
          <span className="text-sm text-slate-700">Weekend trips to Lonavala</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-1.5 w-1.5 rounded-full bg-primary flex-shrink-0" />
          <span className="text-sm text-slate-700">Street photography walks</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-1.5 w-1.5 rounded-full bg-primary flex-shrink-0" />
          <span className="text-sm text-slate-700">Coastal food trails</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-1.5 w-1.5 rounded-full bg-primary flex-shrink-0" />
          <span className="text-sm text-slate-700">Heritage building tours</span>
        </div>
      </div>
    </div>
    {/* दूसरी कार्ड */}
    <div className="bg-white rounded-xl border border-slate-200 p-4">
      <div className="flex items-center gap-2 mb-3">
        <div className="p-1.5 bg-primary/10 rounded-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-map-pin h-4 w-4 text-primary"
          >
            <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        </div>
        <h3 className="text-base font-bold text-slate-800">Nearby Destinations</h3>
      </div>
      <div className="space-y-2">
        {/* स्थानें और दूरी */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-1.5 w-1.5 rounded-full bg-primary" />
            <span className="text-sm text-slate-700">Lonavala</span>
          </div>
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs border-primary/30 text-primary">
            83 km
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-1.5 w-1.5 rounded-full bg-primary" />
            <span className="text-sm text-slate-700">Alibaug</span>
          </div>
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs border-primary/30 text-primary">
            95 km
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-1.5 w-1.5 rounded-full bg-primary" />
            <span className="text-sm text-slate-700">Pune</span>
          </div>
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs border-primary/30 text-primary">
            148 km
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-1.5 w-1.5 rounded-full bg-primary" />
            <span className="text-sm text-slate-700">Nashik</span>
          </div>
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs border-primary/30 text-primary">
            165 km
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* डेस्कटॉप व्यू के लिए */}
  
  <Communitydetailactivitie />
  
</section>


{/*<section className="mb-6 md:mb-10">
  <div className="flex items-center justify-between mb-4 md:mb-6">
    <h2 className="text-lg md:text-2xl font-bold text-slate-800">Explore Popular Itineraries</h2>
    <a
      className="text-primary font-medium text-sm flex items-center hover:underline"
      href="/community/mumbai/itineraries"
    >
      View All
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-chevron-right ml-1 h-4 w-4"
      >
        <path d="m9 18 6-6-6-6"></path>
      </svg>
    </a>
  </div>
  <div className="md:hidden space-y-4">
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
      <div className="relative h-32">
        <img
          alt="Mumbai in a Day: A Whirlwind Tour"
          loading="lazy"
          decoding="async"
          data-nimg="fill"
          className="object-cover"
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            inset: 0,
            color: 'transparent',
          }}
          src="/mumbai-skyline.png"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute top-3 right-3">
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-primary text-xs">
            1 Day
          </div>
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="text-white font-bold text-sm line-clamp-1">Mumbai in a Day: A Whirlwind Tour</h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-sm text-slate-600 mb-3 line-clamp-2">
          Experience the best of Mumbai's iconic landmarks and hidden gems in just one day.
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="relative h-6 w-6 rounded-full overflow-hidden">
              <img
                alt="Rahul M."
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: 0,
                  color: 'transparent',
                }}
                src="/assets/images/member-profile-1.png"
              />
            </div>
            <span className="text-xs text-slate-500">Rahul M.</span>
          </div>
          <a
            className="text-primary text-sm font-medium hover:underline"
            href="/community/mumbai/itineraries/mumbai-in-a-day"
          >
            View →
          </a>
        </div>
      </div>
    </div>
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
      <div className="relative h-32">
        <img
          alt="Mumbai Street Food Adventure"
          loading="lazy"
          decoding="async"
          data-nimg="fill"
          className="object-cover"
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            inset: 0,
            color: 'transparent',
          }}
          src="/mumbai-street-food.png"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute top-3 right-3">
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-primary text-xs">
            1 Day
          </div>
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="text-white font-bold text-sm line-clamp-1">Mumbai Street Food Adventure</h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-sm text-slate-600 mb-3 line-clamp-2">
          Embark on a culinary journey through Mumbai's vibrant street food scene.
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="relative h-6 w-6 rounded-full overflow-hidden">
              <img
                alt="Arjun K."
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: 0,
                  color: 'transparent',
                }}
                src="/assets/images/member-profile-5.jpg"
              />
            </div>
            <span className="text-xs text-slate-500">Arjun K.</span>
          </div>
          <a
            className="text-primary text-sm font-medium hover:underline"
            href="/community/mumbai/itineraries/mumbai-street-food-adventure"
          >
            View →
          </a>
        </div>
      </div>
    </div>
  </div>
  <div className="hidden md:grid grid-cols-3 gap-6">
 
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30 h-full flex flex-col">
      <div className="relative h-48 overflow-hidden">
        <img
          alt="Mumbai in a Day: A Whirlwind Tour"
          loading="lazy"
          decoding="async"
          data-nimg="fill"
          className="object-cover"
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            inset: 0,
            color: 'transparent',
          }}
          src="/mumbai-skyline.png"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-white/90 text-primary hover:bg-white/95 backdrop-blur-sm text-xs">
            1 Day
          </div>
        </div>
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <a
          href="/community/mumbai/itineraries/mumbai-in-a-day"
          className="font-bold text-slate-800 mb-2 hover:text-primary transition-colors hover:underline"
        >
          Mumbai in a Day: A Whirlwind Tour
        </a>
        <p className="text-sm text-slate-600 mb-3 line-clamp-2 flex-1">
          Experience the best of Mumbai's iconic landmarks and hidden gems in just one day.
        </p>
        <div className="flex items-center justify-between mt-auto">
          <div className="flex items-center gap-2">
            <div className="relative h-6 w-6 rounded-full overflow-hidden">
              <img
                alt="Rahul M."
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: 0,
                  color: 'transparent',
                }}
                src="/assets/images/member-profile-1.png"
              />
            </div>
            <span className="text-xs text-slate-500">Rahul M.</span>
          </div>
          <div className="flex items-center gap-1 text-xs text-slate-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-calendar h-3 w-3 text-primary"
            >
              <path d="M8 2v4"></path>
              <path d="M16 2v4"></path>
              <rect width="18" height="18" x="3" y="4" rx="2"></rect>
              <path d="M3 10h18"></path>
            </svg>
            <span>May 10, 2024</span>
          </div>
        </div>
        <a
          href="/community/mumbai/itineraries/mumbai-in-a-day"
          className="mt-3 text-primary text-sm font-medium hover:underline"
        >
          View Itinerary →
        </a>
      </div>
    </div>
  
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30 h-full flex flex-col">
      <div className="relative h-48 overflow-hidden">
        <img
          alt="Mumbai Street Food Adventure"
          loading="lazy"
          decoding="async"
          data-nimg="fill"
          className="object-cover"
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            inset: 0,
            color: 'transparent',
          }}
          src="/mumbai-street-food.png"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-white/90 text-primary hover:bg-white/95 backdrop-blur-sm text-xs">
            1 Day
          </div>
        </div>
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <a
          href="/community/mumbai/itineraries/mumbai-street-food-adventure"
          className="font-bold text-slate-800 mb-2 hover:text-primary transition-colors hover:underline"
        >
          Mumbai Street Food Adventure
        </a>
        <p className="text-sm text-slate-600 mb-3 line-clamp-2">
          Embark on a culinary journey through Mumbai's vibrant street food scene.
        </p>
        <div className="flex items-center justify-between mt-auto">
          <div className="flex items-center gap-2">
            <div className="relative h-6 w-6 rounded-full overflow-hidden">
              <img
                alt="Arjun K."
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: 0,
                  color: 'transparent',
                }}
                src="/assets/images/member-profile-5.jpg"
              />
            </div>
            <span className="text-xs text-slate-500">Arjun K.</span>
          </div>
          <a
            href="/community/mumbai/itineraries/mumbai-street-food-adventure"
            className="text-primary text-sm font-medium hover:underline"
          >
            View →
          </a>
        </div>
      </div>
    </div>
   
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30 h-full flex flex-col">
      <div className="relative h-48 overflow-hidden">
        <img
          alt="Mumbai Street Food Adventure"
          loading="lazy"
          decoding="async"
          data-nimg="fill"
          className="object-cover"
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            inset: 0,
            color: 'transparent',
          }}
          src="/mumbai-street-food.png"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-white/90 text-primary hover:bg-white/95 backdrop-blur-sm text-xs">
            1 Day
          </div>
        </div>
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <a
          href="/community/mumbai/itineraries/mumbai-street-food-adventure"
          className="font-bold text-slate-800 mb-2 hover:text-primary transition-colors hover:underline"
        >
          Elephanta Caves Exploration
        </a>
        <p className="text-sm text-slate-600 mb-3 line-clamp-2">
          Discover the ancient rock-cut temples of Elephanta Island, a UNESCO World Heritage Site.
        </p>
        <div className="flex items-center justify-between mt-auto">
          <div className="flex items-center gap-2">
            <div className="relative h-6 w-6 rounded-full overflow-hidden">
              <img
                alt="Arjun K."
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: 0,
                  color: 'transparent',
                }}
                src="/assets/images/member-profile-5.jpg"
              />
            </div>
            <span className="text-xs text-slate-500">Vikram J.</span>
          </div>
          <a
            href="/community/mumbai/itineraries/mumbai-street-food-adventure"
            className="text-primary text-sm font-medium hover:underline"
          >
            View →
          </a>
        </div>
      </div>
    </div>
  </div>
</section>*/}




<CommunityDtlImpact />



      </div>
    </main>



      <Footer />
    </>
  );
};

export default CommunityDtl;
